import React, { Fragment } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import styled from 'styled-components';
import { withStyles } from "@material-ui/core/styles";
import moment from 'moment';
import { Grid, Divider } from "@material-ui/core";
import TypeAheadDropdown from "../../Global/Fields/TypeAheadDropdown";
import GridTextInput from "../../Global/Fields/GridTextInput";
import GridPercentInput from "../../Global/Fields/GridPercentInput";
import GridCurrencyInput from "../../Global/Fields/GridCurrencyInput";
import DatePicker from "material-ui-pickers/DatePicker";
import {StyledLabel} from "components/Global/Fields/StyledInputLabel";
import { transformNumber } from "utils/transformNumber";
import { getConfigItemByParentId } from "store/state/configItems";
import { getDealStages, getDealStatuses, getFundNames, getBrokers, getUserCompanyContacts } from "store/state/enumeratedTypes";
import { getContactsByCompany } from "store/state/contacts";
import { setConfigItemListState, setEnumeratedTypesListState, setEnumeratedFundNames, setEnumeratedTypesContactsListState } from "../../Global/Fields/util";
import { PROJECT_TYPE } from "constants/configItemParents";
import { PIPELINE } from "../../../constants/status";
import SOFT_QUOTE from "../../../constants/dealStages";


const StyledInputLabel = styled('InputLabel')`& {
  font-weight: bold;
}`;

const StyleDatePicker = styled(DatePicker)`&& {
  width:100%;
}`;

const styles = () => ({
  heading: {
    "font-size": "17px;",
  },
  inputField: {
    borderBottom: '1px solid #2196F3',    
    transition: '0.3s',
    '&:hover': {
      borderBottom: '1px solid #21c1f2'
    }
  },
});

class AssetDetails extends React.Component {
  state = {
    projectTypes: [],
    dealStatuses: [],
    dealStages: [], 
    fundNames: [],
    brokerCompanies: [],
    brokerCompanies: [],
    teamMembers: [],
  };

  componentDidMount() {
    this.props.getConfigItemByParentId({ id: PROJECT_TYPE });
    this.props.getDealStatuses();
    this.props.getDealStages();
    this.props.getFundNames();
    this.props.getBrokers();
    this.props.getUserCompanyContacts();
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.configItems && this.props.configItems.configItemByParent) {
      setConfigItemListState(PROJECT_TYPE, "projectTypes", this);
    }
    if (this.props.enumeratedTypes) {
      setEnumeratedTypesListState("deal_statuses", "dealStatuses", this);
      setEnumeratedTypesListState("deal_stages", "dealStages", this);
      setEnumeratedFundNames("fund_names", "fundNames", this, "funds");
      setEnumeratedTypesListState("brokers", "brokerCompanies", this);
      setEnumeratedTypesContactsListState("user_company_contacts", "teamMembers", this);
    }

    const prevSelectedBrokerId = prevProps.deal.brokerCompanyId;
    if (this.props.deal.brokerCompanyId !== prevSelectedBrokerId) {
      this.props.getContactsByCompany({ companyId: this.props.deal.brokerCompanyId });
    }
  }
 
  hasBrokerContacts = (selectedBrokerId, brokerContacts) =>
  selectedBrokerId &&
  brokerContacts &&
  brokerContacts[selectedBrokerId] &&
  brokerContacts[selectedBrokerId].length > 0;

   render() {
    const {
      classes,
      deal,
      dealError,
      showStageField,
      handleChange,
      handleTextChange,
      setFieldValue,
      brokerContacts,
      otherProps
    } = this.props;

    const {teamMembers} = this.state;
    
    let contacts = [];
    if (this.hasBrokerContacts(deal.brokerCompanyId, brokerContacts)) {
      contacts = brokerContacts[deal.brokerCompanyId].map(x => ({
        label: `${x.firstName ? x.firstName :""} ${x.lastName ? x.lastName : ""}`,
        value: x.id
      }));
    }

    return (
      <Fragment>
        <Grid item xs={12}>
          <div className="title-component">
            Asset Details
          </div>
        </Grid>
        <Grid item xs ={10}>
          <Divider style={{marginBottom:"15px"}}></Divider>
        </Grid>
        <Grid container item={true} xs={12}>
          <GridTextInput            
            error={dealError.name}
            name="name"
            label="Deal Name"
            placeholder="Deal Name"
            value={deal.name}
            onChange={handleTextChange}
            shouldShow={true}
            xsLayout={{label:4,field:6}}
          />
        </Grid>
        <Grid container item={true} xs={12}>
          <TypeAheadDropdown
            name="fundId"
            label="Group"
            error={dealError.fundId}
            selectStyles={{
              control: (provided, state) => ({
                ...provided,
                boxShadow: 'none',
                border:'none',
                padding: 0
              }),
              indicatorSeparator: (provided, state) => ({
                ...provided,
                display:'none'
              }),
              container: (provided, state) => ({
                ...provided,
                borderBottom: '1px solid #2196F3',
                transition: 'border 0.1s',
                '&:hover': {
                  cursor: 'pointer',
                  borderBottom: '1px solid #21c1f2'
                },
                padding: '0'
              }),
            }}
            placeholder="Group"
            value={deal.fundId}
            options={this.state.fundNames}
            handleChange={data => handleChange("fundId", data)}
            shouldShow={true}
            usingFormik={false}
          />
        </Grid>
        <Grid container item={true} xs={12}>
          <GridTextInput
            name="jvPartner"
            label="JV Partner"
            placeholder="JV Partner"
            value={deal.jvParner}
            onChange={handleTextChange}
            shouldShow={true}
            xsLayout={{label:4,field:6}}
          />
        </Grid>
      
        <Grid container item={true} xs={12}>
          <GridTextInput
            name="collateralization"
            label="Cross-Collateralized"
            placeholder="Cross-Collateralized"
            value={deal.collateralization}
            onChange={handleTextChange}
            shouldShow={true}
            xsLayout={{label:4,field:6}}
          />
        </Grid>
        <Grid container item={true} xs={12}>
          <TypeAheadDropdown
            name="dealStatusId"
            label="Status"
            placeholder="Status"
            selectStyles={{
              control: (provided, state) => ({
                ...provided,
                boxShadow: 'none',
                border:'none',
                padding: 0
                
              }),
              indicatorSeparator: (provided, state) => ({
                ...provided,
                display:'none'
              }),
              container: (provided, state) => ({
                ...provided,
                borderBottom: '1px solid #2196F3',
                transition: 'border 0.1s',
                '&:hover': {
                  cursor: 'pointer',
                  borderBottom: '1px solid #21c1f2'
                },
                padding: '0'
              }),
            }}
            options={this.state.dealStatuses}
            handleChange={data => handleChange("dealStatusId", data)}
            shouldShow={true}
            defaultValue={ {value: `${PIPELINE}`, label: "Pipeline"} }
            usingFormik={false}
          />
        </Grid>
        <Grid container item={true} xs={12}>
          <TypeAheadDropdown
            name="stageId"
            label="Stage"
            placeholder="Stage"
            value={deal.StageId}
            selectStyles={{
              control: (provided, state) => ({
                ...provided,
                boxShadow: 'none',
                border:'none',
                padding: 0
                
              }),
              indicatorSeparator: (provided, state) => ({
                ...provided,
                display:'none'
              }),
              container: (provided, state) => ({
                ...provided,
                borderBottom: '1px solid #2196F3',
                transition: 'border 0.1s',
                '&:hover': {
                  cursor: 'pointer',
                  borderBottom: '1px solid #21c1f2'
                },
                padding: '0'
              }),
            }}
            options={this.state.dealStages}
            handleChange={data => handleChange("stageId", data)}
            shouldShow={showStageField}
            defaultValue={ {value: `${SOFT_QUOTE}`, label: "Soft Quote"} }
            usingFormik={false}
          />
        </Grid>
        <Grid container item={true} xs={12}>
          <TypeAheadDropdown
            name="projectTypeId"
            label="Project Type"
            placeholder="Project Type"
            selectStyles={{
              control: (provided, state) => ({
                ...provided,
                boxShadow: 'none',
                border:'none',
                padding: 0
                
              }),
              indicatorSeparator: (provided, state) => ({
                ...provided,
                display:'none'
              }),
              container: (provided, state) => ({
                ...provided,
                borderBottom: '1px solid #2196F3',
                transition: 'border 0.1s',
                '&:hover': {
                  cursor: 'pointer',
                  borderBottom: '1px solid #21c1f2'
                },
                padding: '0'
              }),
            }}
            options={this.state.projectTypes}
            value={deal.projectTypeId}
            handleChange={data => handleChange("projectTypeId", data)}
            shouldShow={true}
            usingFormik={false}
          />
        </Grid>

        <Grid container item={true} xs={12}>
          <Grid item xs={4}>
            <StyledLabel htmlFor={`targetedClosing`} text={`Targeted Closing`}/>
          </Grid>
          <Grid item xs={6}>
            <StyleDatePicker 
              InputProps={{
                disableUnderline:true,
              }}
              style={{borderBottom:"1px solid #2196F3"}}
              name="targetedClosing"
              format="MM/DD/YYYY"
              keyboard={true}
              {...otherProps}
              value={deal.targetedClosing}
              onChange={selectedOption => { selectedOption.value = moment(selectedOption).format( "MM/DD/YYYY" ); 
                          return handleChange("targetedClosing", selectedOption); 
                        }} 
              />
          </Grid>
        </Grid>

        <Grid container item={true} xs={12}>
          <GridCurrencyInput
            name="desiredLoanAmount"
            label="Desired Loan Amount"
            placeholder="Desired Loan Amount"
            type="number"
            value={deal.desiredLoanAmount}
            onBlur={item => {
              handleTextChange({
                target: {
                  name: "desiredLoanAmount",
                  value: transformNumber(item.target.value)
                }
              });
            }}
            shouldShow={true}
            xsLayout={{label:4,field:6}}
          />
        </Grid>
        <Grid container item={true} xs={12}>
          <TypeAheadDropdown
            name="brokerCompanyId"
            label="Broker Company"
            placeholder="Broker Company"
            selectStyles={{
              control: (provided, state) => ({
                ...provided,
                boxShadow: 'none',
                border:'none',
                padding: 0
                
              }),
              indicatorSeparator: (provided, state) => ({
                ...provided,
                display:'none'
              }),
              container: (provided, state) => ({
                ...provided,
                borderBottom: '1px solid #2196F3',
                transition: 'border 0.1s',
                '&:hover': {
                  cursor: 'pointer',
                  borderBottom: '1px solid #21c1f2'
                },
                padding: '0'
              }),
            }}
            options={this.state.brokerCompanies}
            handleChange={data => handleChange("brokerCompanyId", data)}
            shouldShow={true}            
            usingFormik={false}
          />
        </Grid>
        <Grid container item={true} xs={12}>
          <TypeAheadDropdown
            name="brokerContactId"
            label="Broker Contact"
            placeholder="Broker Contact"
            selectStyles={{
              control: (provided, state) => ({
                ...provided,
                boxShadow: 'none',
                border:'none',
                padding: 0
                
              }),
              indicatorSeparator: (provided, state) => ({
                ...provided,
                display:'none'
              }),
              container: (provided, state) => ({
                ...provided,
                borderBottom: '1px solid #2196F3',
                transition: 'border 0.1s',
                '&:hover': {
                  cursor: 'pointer',
                  borderBottom: '1px solid #21c1f2'
                },
                padding: '0'
              }),
            }}
            options={contacts}
            handleChange={data => handleChange("brokerContactId", data)}
            shouldShow={true}            
            usingFormik={false}
          />
        </Grid>

        <Grid container item={true} xs={12}>
          <TypeAheadDropdown
            name="teamMemberId"
            label="Team Member"
            placeholder="Team Member"
            selectStyles={{
              control: (provided, state) => ({
                ...provided,
                boxShadow: 'none',
                border:'none',
                padding: 0
                
              }),
              indicatorSeparator: (provided, state) => ({
                ...provided,
                display:'none'
              }),
              container: (provided, state) => ({
                ...provided,
                borderBottom: '1px solid #2196F3',
                transition: 'border 0.1s',
                '&:hover': {
                  cursor: 'pointer',
                  borderBottom: '1px solid #21c1f2'
                },
                padding: '0'
              }),
            }}
            options={teamMembers}
            value={deal.teamMemberId}
            handleChange={data => handleChange("teamMemberId", data)}
            shouldShow={true}
            usingFormik={false}
          />
        </Grid>

        <Grid container item={true} xs={12}>
          <TypeAheadDropdown
            name="assetManagerId"
            label="Asset Manager"
            placeholder="Asset Manager"
            selectStyles={{
              control: (provided, state) => ({
                ...provided,
                boxShadow: 'none',
                border:'none',
                padding: 0
                
              }),
              indicatorSeparator: (provided, state) => ({
                ...provided,
                display:'none'
              }),
              container: (provided, state) => ({
                ...provided,
                borderBottom: '1px solid #2196F3',
                transition: 'border 0.1s',
                '&:hover': {
                  cursor: 'pointer',
                  borderBottom: '1px solid #21c1f2'
                },
                padding: '0'
              }),
            }}
            options={teamMembers}
            value={deal.assetManagerId}
            handleChange={data => handleChange("assetManagerId", data)}
            shouldShow={true}
            usingFormik={false}
          />
        </Grid>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const { loading, configItems, enumeratedTypes, contacts} = state;
  return {
    loading,
    configItems,
    enumeratedTypes: enumeratedTypes.enumeratedTypes,
    brokerContacts: contacts.contactsByCompany, 
  };
};

export default compose(
  connect(
    mapStateToProps,
    {
      getConfigItemByParentId,
      getDealStages,
      getDealStatuses,
      getFundNames,
      getBrokers,
      getContactsByCompany,  
      getUserCompanyContacts,
    }
  )
)(AssetDetails);
